import cContainer from './cContainer.vue';

export default {
  install(Vue) {
    Vue.component('cContainer', cContainer);
  },
};
